import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../../Modal';
import Spinner from '../../Spinner';
import Form, { FormBody, FormActions, TextInput, ColorInput } from '../../Form';
import ItemModify from '../../Form/ItemModify';

@inject('qcFlagStore')
@observer
class QCFlagModify extends Component {
  render() {
    const { qcFlagStore, params } = this.props;

    return (
       <ItemModify
       title='QC Flag'
       slug = '/qc/flag'
       store = {qcFlagStore}
       itemFields = {[
         { label: 'Id', key: 'id', type: 'text', readOnly:true, editOnly:true },
         { label: 'Caption', key: 'caption', type: 'text' },
         { label: 'Description', key: 'description', type: 'text' },
         { label: 'Color', key: 'color', type: 'color' },
       ]}
       params={params}
       />
    );
  }
}

export default QCFlagModify;



// WEBPACK FOOTER //
// ./src/components/QCRule/QCFlags/QCFlagModify.js